import { StaticImage } from "gatsby-plugin-image";
import React from "react";

export interface CaseStudy {
  id: string;
  title: string;
  description: string;
  href: string;
  image: React.ReactNode;
  websiteUrl?: string;
}

export const caseStudies: CaseStudy[] = [
  {
    id: "autotrader-specialty",
    title: "Autotrader Specialty",
    description:
      "As a trusted Autotrader partner, Airtight designed, built, and manages their suite of Specialty sites – Classics, Motorcycles, and RVs.",
    href: "/portfolio/autotrader-specialty",
    websiteUrl: "https://classics.autotrader.com/",
    image: (
      <StaticImage
        src="../images/portfolio/featured-autotrader-specialty.jpg"
        alt="Autotrader Specialty"
        placeholder="blurred"
        width={600}
        height={400}
        quality={80}
        transformOptions={{ cropFocus: "center" }}
        style={{
          width: "100%",
        }}
        objectFit="cover"
      />
    ),
  },
  {
    id: "act-work-ready-communities",
    title: "ACT Work Ready Communities",
    description:
      "ACT needed a central hub to administer its Work Communities, an ambitious program intended to bring employers and job seekers together for more prosperous communities.",
    href: "/portfolio/act-work-ready-communities",
    websiteUrl: "https://www.workreadycommunities.org/",
    image: (
      <StaticImage
        src="../images/portfolio/featured-act-work-ready-communities.jpg"
        alt="ACT Work Ready Communities"
        placeholder="blurred"
        width={600}
        height={400}
        quality={80}
        transformOptions={{ cropFocus: "center" }}
        style={{
          width: "100%",
        }}
        objectFit="cover"
      />
    ),
  },
  {
    id: "cricket-adlab",
    title: "Cricket AdLab",
    description:
      "When an Atlanta advertising agency approached Airtight about developing a complex web application for its client AT&T, we jumped at the opportunity. The application would be used by thousands of businesses who sell AT&T’s Cricket Wireless service. We knew our web development team was up to the task.",
    href: "/portfolio/cricket-adlab",
    image: (
      <StaticImage
        src="../images/portfolio/featured-cricket-ad-builder.jpg"
        alt="Cricket AdLab"
        placeholder="blurred"
        width={600}
        height={400}
        quality={80}
        transformOptions={{ cropFocus: "center" }}
        style={{
          width: "100%",
        }}
        objectFit="cover"
      />
    ),
  },
  {
    id: "manheim-auctions",
    title: "Manheim Auctions",
    description:
      "Manheim approached Airtight about developing an interactive application that would show the human side of the Manheim-dealer relationship. The results are something to shout about.",
    href: "/portfolio/manheim-auctions",
    image: (
      <StaticImage
        src="../images/portfolio/feature-secondary-manheim-auctions-vertical.jpg"
        alt="Manheim Auctions"
        placeholder="blurred"
        width={600}
        height={400}
        quality={80}
        transformOptions={{ cropFocus: "center" }}
        style={{
          width: "100%",
        }}
        objectFit="cover"
      />
    ),
  },
];

export const portfolioSites: CaseStudy[] = [
  {
    id: "monarch-private-capital",
    title: "Monarch Private Capital",
    description:
      "One of the premier ESG investment groups is located here in Atlanta. This site lets users understand the powerful impact of Monarch’s investments in communities around the country.",
    href: "https://www.monarchprivate.com/",
    image: (
      <StaticImage
        src="../images/portfolio/featured-monarch-private-capital.jpg"
        alt="Monarch Private Capital"
        placeholder="blurred"
        width={600}
        height={400}
        quality={80}
        transformOptions={{ cropFocus: "center" }}
        style={{
          width: "100%",
          height: "200px",
        }}
        objectFit="cover"
      />
    ),
  },
  {
    id: "atrium-health-navicent",
    title: "Atrium Health Navicent",
    description:
      "Georgia’s second largest hospital system, based in Macon, has relied on Airtight for custom web development and Internet consulting for more than 12 years.",
    href: "https://navicenthealth.org/",
    image: (
      <StaticImage
        src="../images/portfolio/featured-navicent-health.jpg"
        alt="Atrium Health Navicent"
        placeholder="blurred"
        width={600}
        height={400}
        quality={80}
        transformOptions={{ cropFocus: "center" }}
        style={{
          width: "100%",
          height: "200px",
        }}
        objectFit="cover"
      />
    ),
  },
  {
    id: "real-advisory",
    title: "Real Advisory",
    description:
      "Real Advisory is your trusted partner in driving sales program development and revenue growth through effective customer relationship management strategies.",
    href: "https://www.real-advisory.com/",
    image: (
      <StaticImage
        src="../images/portfolio/featured-real-advisory.jpg"
        alt="Real Advisory"
        placeholder="blurred"
        width={600}
        height={400}
        quality={80}
        transformOptions={{ cropFocus: "center" }}
        style={{
          width: "100%",
          height: "200px",
        }}
        objectFit="cover"
      />
    ),
  },
  {
    id: "central-dispatch",
    title: "Central Dispatch",
    description:
      "This website is a Resource Hub to learn more about our latest features like User Management, Transactional Ratings, and Advanced Search.",
    href: "https://resources.centraldispatch.com/",
    image: (
      <StaticImage
        src="../images/portfolio/featured-central-dispatch.jpg"
        alt="Central Dispatch"
        placeholder="blurred"
        width={600}
        height={400}
        quality={80}
        transformOptions={{ cropFocus: "center" }}
        style={{
          width: "100%",
          height: "200px",
        }}
        objectFit="cover"
      />
    ),
  },
  {
    id: "element-at-manheim",
    title: "Element at Manheim",
    description:
      "Element asked us to design and develop a site to feature their quarterly promotions, Rewards Program, and additional features.",
    href: "https://elementatmanheim.com/",
    image: (
      <StaticImage
        src="../images/portfolio/featured-element-at-manheim.jpg"
        alt="Element at Manheim"
        placeholder="blurred"
        width={600}
        height={400}
        quality={80}
        transformOptions={{ cropFocus: "center" }}
        style={{
          width: "100%",
          height: "200px",
        }}
        objectFit="cover"
      />
    ),
  },
  // {
  //   id: "asbn-coworks",
  //   title: "ASBN Coworks",
  //   description:
  //     "A new coworking space in the heart of Atlanta, ASBN Coworks turned to Airtight to design and develop their site to promote and manage their memberships.",
  //   href: "https://www.asbncoworks.com/",
  //   image: (
  //     <StaticImage
  //       src="../images/portfolio/featured-asbn-coworks.jpg"
  //       alt="ASBN Coworks"
  //       placeholder="blurred"
  //       width={600}
  //       height={400}
  //       quality={80}
  //       transformOptions={{ cropFocus: "center" }}
  //       style={{
  //         width: "100%",
  //         height: "200px",
  //       }}
  //       objectFit="cover"
  //     />
  //   ),
  // },
  {
    id: "b2b-autotrader",
    title: "B2B Autotrader",
    description:
      "Car dealers and manufacturers know the Autotrader name well. This site builds upon Autotrader’s excellent reputation and informs the industry of the wide range of solutions Autotrader offers.",
    href: "https://b2b.autotrader.com/",
    image: (
      <StaticImage
        src="../images/portfolio/featured-b2b-autotrader.jpg"
        alt="B2B Autotrader"
        placeholder="blurred"
        width={600}
        height={400}
        quality={80}
        transformOptions={{ cropFocus: "center" }}
        style={{
          width: "100%",
          height: "200px",
        }}
        objectFit="cover"
      />
    ),
  },
  {
    id: "kelley-blue-book-b2b",
    title: "Kelley Blue Book B2B",
    description:
      "KBB is one of the most trusted names in the automotive industry. This site informs car dealers about the numerous marketing services that helps KBB achieve greater sales.",
    href: "https://b2b.kbb.com/",
    image: (
      <StaticImage
        src="../images/portfolio/featured-b2b-kbb.jpg"
        alt="Kelley Blue Book B2B"
        placeholder="blurred"
        width={600}
        height={400}
        quality={80}
        transformOptions={{ cropFocus: "center" }}
        style={{
          width: "100%",
          height: "200px",
        }}
        objectFit="cover"
      />
    ),
  },
  {
    id: "camp-360",
    title: "CAMP 360",
    description:
      "Cox Automotive is home to some of the best-known names in the automotive industry. This site showcases the power of the partnership.",
    href: "https://kbb-autotrader-oem.com/",
    image: (
      <StaticImage
        src="../images/portfolio/featured-camp-360.jpg"
        alt="CAMP 360"
        placeholder="blurred"
        width={600}
        height={400}
        quality={80}
        transformOptions={{ cropFocus: "center" }}
        style={{
          width: "100%",
          height: "200px",
        }}
        objectFit="cover"
      />
    ),
  },
  {
    id: "manheim-b2b",
    title: "Manheim B2B",
    description:
      "Airtight supports the world’s largest car auction with this and numerous other websites that aim to build an even stronger bond between the automotive company and its valuable customers.",
    href: "https://www.mymanheim.com/",
    image: (
      <StaticImage
        src="../images/portfolio/featured-mymanheim.jpg"
        alt="Manheim B2B"
        placeholder="blurred"
        width={600}
        height={400}
        quality={80}
        transformOptions={{ cropFocus: "center" }}
        style={{
          width: "100%",
          height: "200px",
        }}
        objectFit="cover"
      />
    ),
  },
  {
    id: "act-cel",
    title: "ACT’s Center for Equity in Learning",
    description:
      "Educators around the world are collaborating on how they can foster equity in learning. This website serves as a hub for the exchange of helpful information for educators.",
    href: "https://equityinlearning.act.org/",
    image: (
      <StaticImage
        src="../images/portfolio/featured-act-cel.jpg"
        alt="ACT’s Center for Equity in Learning"
        placeholder="blurred"
        width={600}
        height={400}
        quality={80}
        transformOptions={{ cropFocus: "center" }}
        style={{
          width: "100%",
          height: "200px",
        }}
        objectFit="cover"
      />
    ),
  },
  {
    id: "river-sand-inc",
    title: "River Sand, Inc.",
    description:
      "RSI provides bulk sand, soil, and gravel to North Georgia and the Greater Atlanta area. This site helps consumers understand their options and support customer service initiatives.",
    href: "https://riversandinc.com/",
    image: (
      <StaticImage
        src="../images/portfolio/featured-river-sand-inc.jpg"
        alt="River Sand, Inc."
        placeholder="blurred"
        width={600}
        height={400}
        quality={80}
        transformOptions={{ cropFocus: "center" }}
        style={{
          width: "100%",
          height: "200px",
        }}
        objectFit="cover"
      />
    ),
  },
];

/**
 * Get related case studies by excluding the current case study
 * @param currentId - The ID of the current case study to exclude
 * @param limit - Maximum number of related studies to return (default: 2)
 */
export function getRelatedCaseStudies(
  currentId: string,
  limit: number = 4
): Array<{
  title: string;
  description: string;
  path: string;
  image: React.ReactNode;
}> {
  return caseStudies
    .filter((study) => study.id !== currentId)
    .slice(0, limit)
    .map((study) => ({
      title: study.title,
      description: study.description,
      path: study.href,
      image: study.image,
    }));
}
